export class CacheTable {
    public name: string;
}